import { render, staticRenderFns } from "./ListAgencies.vue?vue&type=template&id=5bc07e8c&scoped=true"
import script from "./ListAgencies.vue?vue&type=script&lang=ts"
export * from "./ListAgencies.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc07e8c",
  null
  
)

export default component.exports